import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import CreateCurrency from './create'

import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import IndianaScroller from 'react-indiana-drag-scroll'

const CurrenciesToolbar = (props) => {
  const { selected, add, edit } = props

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Monedas
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title={"Editar Moneda "}>
            <IconButton onClick={edit}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
      <Tooltip title="Añadir moneda">
        <IconButton onClick={add}>
          <AddIcon />
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

const Currencies = () => {
  const app = React.useContext(AppContext)  
  const { current } = app
  const { currencies, detail } = app.currencies
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }
  return (
    <IndianaScroller>
    <Stack>
      <CurrenciesToolbar selected={current} add={openD} edit={openD} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell alignt="left">Nombre</TableCell>
              <TableCell alignt="left">Tasa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currencies.map((curency) => (
              <TableRow
                selected={current && current.id == curency.id}
                onClick={() => current && current.id == curency.id?detail(false):detail(curency)}
                key={curency.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{curency.name}</TableCell>
                <TableCell align="left">{curency.rate}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CreateCurrency open={open} model={current} close={() => setOpen(false)}/>
    </Stack>
    </IndianaScroller>
  )
}
export default Currencies